export default {"src":"/_next/static/media/questionnaire-illustration.543022c2.svg","height":127,"width":127};